export default "<h1 class=\"page-title\">Japanese</h1>\n<whiskey-list [whiskeyList]=\"whiskeyList\"></whiskey-list>";